<ion-header>
  <ion-toolbar>
    <ion-title>Payout Methods</ion-title>
    <ion-buttons slot="start">
      <ion-menu-button autoHide="false"></ion-menu-button>
      <ion-back-button defaultHref="/driver"></ion-back-button>
    </ion-buttons>
    <ion-buttons slot="end">
      <ion-button (click)="addPaymentMethod()">
        <ion-icon name="add"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content>
  <div class="loading-container" *ngIf="loading">
    <ion-spinner></ion-spinner>
    <p>Loading payout methods...</p>
  </div>

  <div class="empty-state" *ngIf="!loading && paymentMethods.length === 0">
    <ion-icon name="card-outline" class="empty-icon"></ion-icon>
    <h2>No payout Methods</h2>
    <p>Add your first payout method to start receiving payments</p>
    <ion-button (click)="addPaymentMethod()" fill="solid">
      <ion-icon name="add" slot="start"></ion-icon>
      Add Payout Method
    </ion-button>
  </div>

  <ion-list *ngIf="!loading && paymentMethods.length > 0">
    <ion-item-sliding *ngFor="let method of paymentMethods">
      <ion-item button (click)="viewPaymentMethod(method)">
        <ion-icon name="card-outline" slot="start"></ion-icon>
        <ion-label>
          <h2>{{ getPaymentMethodTypeLabel(method) }}</h2>
          <p>{{ getPaymentMethodDetails(method) }}</p>
        </ion-label>
        <ion-badge slot="end" color="primary" *ngIf="method.metodoSelecionado">
          Active
        </ion-badge>
      </ion-item>

      <ion-item-options side="end">
        <ion-item-option color="primary" (click)="editPaymentMethod(method)">
          <ion-icon name="create-outline" slot="icon-only"></ion-icon>
        </ion-item-option>
        <ion-item-option color="danger" (click)="deletePaymentMethod(method, $event)">
          <ion-icon name="trash-outline" slot="icon-only"></ion-icon>
        </ion-item-option>
      </ion-item-options>
    </ion-item-sliding>
  </ion-list>

  <ion-fab
    vertical="bottom"
    horizontal="end"
    slot="fixed"
    *ngIf="!loading && paymentMethods.length > 0"
  >
    <ion-fab-button (click)="addPaymentMethod()">
      <ion-icon name="add"></ion-icon>
    </ion-fab-button>
  </ion-fab>
</ion-content>
